module.exports = __webpack_public_path__ + "static/img/index_ad_hd_old.ab7e117.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/index_ad_hd_old.png
// module id = j5do
// module chunks = 192